import { openMediaPreview } from '../../../slice';
import { Store } from '../../../store';
import { Csv, Excel, Pdf, Placeholder, Ppt, Rar, Txt, Word, Zip } from '../../rootAccess';
import * as constants from '../constants';
import logger from '../../../Helpers/logger';

// Recalculates Image/Video Width and Height for Multiple Platforms
export const calculateWidthAndHeight = (width, height) => {
    let response = {};

    switch (true) {
        // Horizontal Video
        case width > height: {
            let resultHeight = Math.round((height / width) * constants.MAX_WIDTH_WEB),
                resultHeightAnd = Math.round((height / width) * constants.MAX_WIDTH_AND);

            response = {
                webWidth: constants.MAX_WIDTH_WEB,
                webHeight: resultHeight > constants.MIN_HEIGHT_WEB ? resultHeight : constants.MIN_HEIGHT_WEB,
                androidWidth: constants.MAX_WIDTH_AND,
                androidHeight: resultHeightAnd > constants.MIN_HEIGHT_AND ? resultHeightAnd : constants.MIN_HEIGHT_AND,
            };
            break;
        }
        // Vertical Video
        case width < height:
            response = {
                webWidth: constants.MIN_WIDTH_WEB,
                webHeight: constants.MAX_HEIGHT_WEB,
                androidWidth: constants.MIN_WIDTH_AND,
                androidHeight: constants.MAX_HEIGHT_AND,
            };
            break;

        // Default/Square Video
        default:
            response = {
                webWidth: constants.MAX_WIDTH_WEB,
                webHeight: constants.MAX_WIDTH_WEB,
                androidWidth: constants.MAX_WIDTH_AND,
                androidHeight: constants.MAX_WIDTH_AND,
            };
            break;
    }
    return response;
};

export const getMediaDimension = (blobUrl, mediaType) => {
    return new Promise((resolve, _reject) => {
        if (mediaType === 'image') {
            const image = new Image();
            image.onload = function () {
                const { naturalWidth: width, naturalHeight: height } = this;
                resolve(calculateWidthAndHeight(width, height));
            };
            image.onerror = error => {
                logger.error('Error loading image:', error);
                resolve(calculateWidthAndHeight(0, 0));
            };
            image.src = blobUrl;
        } else {
            const video = document.createElement('video');
            video.addEventListener(
                'loadedmetadata',
                () => {
                    const { videoWidth: width, videoHeight: height } = video;
                    resolve(calculateWidthAndHeight(width, height));
                },
                false,
            );
            video.src = blobUrl;
            video.addEventListener('error', event => {
                logger.error('Error loading video:', event);
                resolve(calculateWidthAndHeight(0, 0));
            });
        }
    });
};

/**
 * @param  {string} name=""
 * find last "DOT" and get file Type
 */
export function getExtension(name = '') {
    if (!name) return '';
    const lastDot = name.substring(name.lastIndexOf('.') + 1, name.length);
    return '.' + lastDot;
}

const getFile = (fileType, extension) => {
    const getLowercase = extension ? extension.toString().toLowerCase() : '';
    if (getLowercase === '.doc' || getLowercase === '.docx' || fileType === 'application/msword') {
        return Word;
    } else if (getLowercase === '.xls' || getLowercase === '.xlsx' || fileType === 'application/vnd.ms-excel') {
        return Excel;
    } else if (getLowercase === '.txt' || fileType === 'text/plain') {
        return Txt;
    } else if (getLowercase === '.pdf' || fileType === 'application/pdf') {
        return Pdf;
    } else if (getLowercase === '.csv' || fileType === 'application/csv') {
        return Csv;
    } else if (
        getLowercase === '.ppt' ||
        getLowercase === '.pptx' ||
        fileType === 'application/ppt' ||
        fileType === 'application/pptx'
    ) {
        return Ppt;
    } else if (
        getLowercase === '.zip' ||
        fileType === 'application/zip' ||
        fileType === 'application/x-zip-compressed'
    ) {
        return Zip;
    } else if (getLowercase === '.rar' || fileType === 'application/rar' || fileType === 'application/vnd.rar') {
        return Rar;
    } else {
        return Placeholder;
    }
};

export const getFileFromType = (fileType, extension) => {
    return getFile(fileType, extension);
};

export const handleMediaClick = ({ message, channelId, selectedIndex }) => {
    Store.dispatch(openMediaPreview({ message, channelId, selectedIndex }));
};
